import axios from 'axios'

import './axiosSessionBootstrap'
import config from './config'
import { getAuthToken } from './authToken'

function getOrCreateClientInstallId() {
  try {
    const STORAGE_KEY = 'eclipsera_client_install_id_v1'
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing && existing.trim().length >= 8) return existing.trim()
    const id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 26)}`
    localStorage.setItem(STORAGE_KEY, id)
    return id
  } catch {
    return ''
  }
}

/** Same contract as `nativeHardwareMac.ts` — only native shell sets real MAC. */
function getHardwareMacForRequest() {
  try {
    if (typeof window === 'undefined') return ''
    const raw = window.__ECLIPERA_HARDWARE_MAC__
    if (typeof raw !== 'string') return ''
    const m = raw.trim()
    if (
      !/^([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2})$/.test(
        m
      )
    ) {
      return ''
    }
    const first = parseInt(m.slice(0, 2), 16)
    if (Number.isNaN(first) || first & 1) return ''
    return m.toUpperCase()
  } catch {
    return ''
  }
}

export default async function callAPI(endpoint, method = 'get', data) {
  const token = getAuthToken()
  const apiKey = process.env.REACT_APP_X_API_KEY
  const installId = typeof window !== 'undefined' ? getOrCreateClientInstallId() : ''
  const mac = typeof window !== 'undefined' ? getHardwareMacForRequest() : ''
  const configS = {
    method,
    // url: `${config.server}:${config.port}${config.baseURL}/${endpoint}`,
    url: `${config.server}${config.baseURL}/${endpoint}`,
    withCredentials: true,
    headers: {
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...(apiKey && { 'x-api-key': apiKey }),
      ...(installId && { 'x-device-id': installId }),
      ...(mac && { 'x-mac-address': mac }),
    },
    data,
  }
  const res = await axios(configS)
  
  // Check if backend sent a new token (when current token expires in < 1 day)
  const newToken = res.headers['x-new-token']
  if (newToken) {
    const { setAuthToken } = require('./authToken')
    setAuthToken(newToken)
    console.log('Token refreshed automatically')
  }
  
  return res.data
}
